import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { purchaseMotionsSelector } from '../../../selectors/PurchaseMotionSelectors';
export const useHubPurchaseMotions = ({
  skuId
}) => {
  const isAppReady = useGlobalLoading();
  const purchaseMotions = useAppSelector(state => {
    if (!isAppReady || !skuId) return [];
    return purchaseMotionsSelector(state, {
      skuId
    });
  });
  return purchaseMotions;
};